// Company ki apni websites jo dashboard ke andar list hoti hain. Click par asli
// site nayi tab me khulti hai — kaam wahin hota hai, yahan sirf shortcut hai.
// Nayi site jodni ho to bas is list me ek entry add karo (permission apne aap
// Users → Edit Access me tick karne ke liye aa jayegi).
export const COMPANY_SITES = [
  {
    key: 'site_tools_bainsla',
    name: 'Audio & PDF Converter',
    url: 'https://tools.bainslamusic.com',
    description: 'Audio aur PDF convert karne wale tools',
    color: '#667eea',
  },
  {
    key: 'site_intubelive',
    name: 'Intube Live',
    url: 'https://intubelive.com',
    description: 'Intube Media ki live site',
    color: '#f5576c',
  },
  {
    key: 'site_intubelive_1',
    name: 'Intube Live 1',
    url: 'https://live1.intubelive.com',
    description: 'Intube Live ka server 1',
    color: '#fa8c16',
  },
  {
    key: 'site_intubelive_2',
    name: 'Intube Live 2',
    url: 'https://live2.intubelive.com',
    description: 'Intube Live ka server 2',
    color: '#13c2c2',
  },
  {
    key: 'site_tag_bainsla',
    name: 'Bainsla Tag',
    url: 'https://tag.bainslamusic.com',
    description: 'Tagging / metadata ka kaam',
    color: '#43a047',
  },
];

export const COMPANY_SITE_PERMS = COMPANY_SITES.map(s => s.key);

/** Sidebar menu key for a site — App.js isse asli site nayi tab me kholta hai. */
export const SITE_MENU_PREFIX = 'site::';

export function siteMenuKey(site) {
  return SITE_MENU_PREFIX + site.url;
}

/** Menu key se site nikalo (nahi mili to null). */
export function siteFromMenuKey(key) {
  if (typeof key !== 'string' || !key.startsWith(SITE_MENU_PREFIX)) return null;
  const url = key.slice(SITE_MENU_PREFIX.length);
  return COMPANY_SITES.find(s => s.url === url) || null;
}

/** Sites this user may open (admin sees all). */
export function visibleSites(isAdmin, perms) {
  if (isAdmin) return COMPANY_SITES;
  const list = Array.isArray(perms) ? perms : [];
  return COMPANY_SITES.filter(s => list.includes(s.key));
}
